import React from 'react';
import ServiceTemplate from '../components/ServiceTemplate';

const AirFreight = () => {
  return (
    <ServiceTemplate
      title="Air Freight"
      subtitle="Fast Cargo Transport"
      description="Fast, reliable air cargo services for time-sensitive shipments between Europe and Africa with priority handling."
      whatIsIt="Air freight is the transportation of cargo by aircraft. It's the fastest mode of international shipping, with transit times measured in days rather than weeks. NETEXEC GLOBAL coordinates air freight between South Africa and Europe, with established routes including Johannesburg to Paris and other major European hubs."
      whoFor="Air freight is for businesses moving time-sensitive cargo, high-value goods, or shipments where speed is critical. It's ideal for urgent orders, perishable goods, or when fast market access is needed."
      whenToUse="Use air freight when transit time is more important than cost. If your cargo needs to reach its destination quickly, or if it's high-value and requires secure, fast transport, air freight is the right choice."
      howWeHelp="NETEXEC GLOBAL coordinates air freight from booking to delivery. We arrange cargo space with reliable carriers, handle documentation and customs clearance, provide real-time tracking, and coordinate delivery at destination."
      benefits={[
        'Fast transit times (days instead of weeks)',
        'Priority handling for urgent shipments',
        'Reliable schedules and frequent departures',
        'Suitable for high-value and time-sensitive cargo',
        'Established routes between South Africa and Europe'
      ]}
      nextSteps="Contact NETEXEC GLOBAL with your cargo details, urgency, and destination. We'll provide air freight options with clear timelines and transparent pricing."
      image="https://images.unsplash.com/photo-1761236099813-6a8189675c49?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85"
    />
  );
};

export default AirFreight;